// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2T5u4","dragIcon":"SortableItem_dragIcon__14oax","disabled":"SortableItem_disabled__ZcDmC"};